

/*eslint-disable*/
import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Spin, Space, DatePicker } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import Message from '../../component/message/message'; // 提示信息弹窗
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import trans from './translation';
import './cohortSetup.css';
import UploadModal from './uploadModal';
const { TabPane } = Tabs;
const CohortSetup = (props) => {
    const [form] = Form.useForm();
    const messageRef = useRef();
    const [tabIndex, setTabIndex] = useState("1");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [funcList, setFuncList] = useState([]);
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [groupMemberTables, setGroupMemberTables] = useState([]);
    const [isUpload, setIsUpload] = useState(false);
    useEffect(() => {
        search(pageSize, 1, "N");
    }, []);

    const search = (pageSizeNew, current, flag, isShowMsg) => {
        setTables([
            {
                cohort: "2023",
                lastUpdateBy: "System Testing",
                statusLastUpdateDate: "2024/03/19",
                toDate: "2024/06/30",
                fromDate: "2023/09/01"
            },
        ]);

    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    const clone = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (checkboxState.length === 1 && Config.funcInfo.canUpdate === "Y") {
                    edit();
                } else if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({ activeInd: 'Y' });
        setGroupMemberTables([]);
        setFlag("add");
        setTabIndex("2");
    }
    const download = () => {
        setIsUpload(true)
    }

    const update = (model, e) => {
        messageShowHandler();
        // searchById();

        initForm({
            cohortId: "TEST_VALUE",
            cohort: "2023",
            programmeCode: "akiv",
            lastUpdateBy: "System Testing",
            statusLastUpdateDate: "2024/3/19",
            status: "Active",
            programme: "akiv",
            toDate: "2024/06/30",
            fromDate: "2023/09/01"
        });
        setFlag("edit");
        setTabIndex("2");
    }


    const edit = () => {
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            cohortId: model.cohortId ?? "",
            cohort: model.cohort ?? "",
            programmeCode: model.programmeCode ?? "",
            lastUpdateBy: model.lastUpdateBy ?? "",
            statusLastUpdateDate: model.statusLastUpdateDate,
            programme: model.programme ?? "",
            toDate: model.toDate ? moment(model.toDate, Config.dateFormatALL) : "",
            fromDate: model.fromDate ? moment(model.fromDate, Config.dateFormatALL) : "",
            status: model.status ?? "",
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        clearSelect();
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        // setIsLoad(true);
        // setSpinInfo(trans.deleteData[Config.backLang]);
        // let deleteModel = checkboxState[0];
        // deleteModel.menuFuncId = Config.funcInfo.funcId;
        // Base.callBackApi("role/delete", deleteModel).then((data) => {
        //     if ("SUCCESS" === data.msg) {
        //         cancel();
        //         search(pageSize, current, "Y", false);
        //         errFrameShow("success", trans.deleteSuccess[Config.backLang]);
        //         props.searchMenu(Config.userInfo.role);//刷新menu
        //     } else {
        //         errFrameShow("error", data.msg);
        //     }
        // }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (values) => {
        messageShowHandler();
        // setIsLoad(true);
        // setSpinInfo(trans.dataBeSaving[Config.backLang])
        // let list = [];
        // for (let item of funcList) {
        //     if (item.children != null) {
        //         for (let iterator of item.children) {
        //             list.push(iterator);
        //             if (Base.isNotEmpty(iterator.children)) {
        //                 for (let subFunc of iterator.children) {
        //                     list.push(subFunc);
        //                 }
        //             }
        //         }
        //     }
        //     list.push(item);
        // }
        // values.funcList = list;
        // let url = "";
        // if (flag === "add") {
        //     url = "role/insert";
        // } else {
        //     url = "role/update"
        //     values.roleId = selectedRowKeys[0];
        //     values.lastUpdatedDate = checkboxState[0].lastUpdatedDate;
        // }
        // values.menuFuncId = Config.funcInfo.funcId;
        // values.roleCode = values.roleCode.toLocaleUpperCase();
        // Base.callBackApi(url, values).then((data) => {
        //     if ("SUCCESS" === data.msg) {
        //         searchById(data.object)
        //         errFrameShow("success", trans.saveSuccess[Config.backLang]);
        //     } else {
        //         errFrameShow("error", data.msg);
        //     }
        // }).catch(err => { }).finally(() => {
        //     setIsLoad(false);
        //     props.searchMenu(Config.userInfo.role);
        // });
    }

    const searchById = (model) => {
        setIsLoading(true);
        Base.callBackApi("role/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let roleModel = data.object;
                initForm(roleModel);
                setCheckboxState([roleModel]);
                setSelectedRowKeys([roleModel.roleId]);
                setFlag("edit");
                setFuncList(roleModel.funcList);
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setGroupMemberTables([]);
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();

        setIsDeleteFrame(true);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }


    // 生成提示信息
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    // 清除提示信息
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }


    const uploadClose = (flag) => {
        // if (flag) {
        //     if (!(Config.userInfo.role.roleCode === "SYS_ADMIN" || Config.userInfo.role.roleCode === "ADMIN") || searchModel.customerMgtId) {
        //         search(pageSize, 1, "N");
        //     }
        //     errFrameShow("success", trans.importSuccess[Config.backLang]);
        // }
        setIsUpload(false);
    }

    /*eslint-disable*/
    const columns = [

        {
            title: 'Cohort',
            dataIndex: 'cohort',
            className: 'tableWidth8',
        },
        {
            title: 'From Date',
            dataIndex: 'fromDate',
            className: 'tableWidth10',
        },
        {
            title: 'To Date',
            dataIndex: 'toDate',
            className: 'tableWidth10',
        },
        {
            title: "Last Update By",
            dataIndex: 'lastUpdateBy',
            className: 'tableWidth10',
        },
        {
            title: "Last Update Date",
            dataIndex: 'statusLastUpdateDate',
            className: 'tableWidth8',
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: 'tableWidth10 sysControls',
            fixed: 'right',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];


    return (
        <div id="container" className="template cohortSetup">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />   
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysSearchRow sysSearchBox'>
                                <div className='sysRow'>

                                    <div className='sysCol'>
                                        <div className="sysTitle programmeParameterSerchTitle">{trans.cohort[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.cohort || ''}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('cohort', e.target.value)} />
                                        </div>
                                    </div>


                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                                {/* <Button type="primary" className="sysBtn btnBlue" onClick={download} hidden={Config.funcInfo.canInsert === "N"} icon={<UploadOutlined />}>{trans.batchUpload[Config.backLang]}</Button> */}
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1200 }}
                                    rowKey="roleId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,          //默认当前页为1
                                        size: "small"
                                    }}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.cohortSetup[Config.backLang]} forceRender={true}>
                            <Form form={form}>
                                <div className='sysRow'>
                                    {/* <div className='sysCol'>
                                        <div className="sysParam cohortSetupSerchTitle">{trans.cohortId[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="cohortId"
                                                getValueFromEvent={(e) => Base.codeChange(e, 20)}
                                            >
                                                <Input type="text" placeholder={trans.cohortId[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div> */}
                                    <div className='sysCol'>
                                        <div className="sysParam cohortSetupSerchTitle">{trans.cohort[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="cohort"
                                            >
                                                <Input type="text" placeholder={trans.cohort[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>


                                </div>

                                <div className='sysRow'>

                                    <div className='sysCol'>
                                        <div className="sysParam cohortSetupSerchTitle">From Date</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="fromDate"
                                            >
                                                <DatePicker type="text" format={"yyyy/MM/DD"} placeholder="From Date" />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam cohortSetupSerchTitle">To Date</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="toDate"
                                            >
                                                <DatePicker type="text" format={"yyyy/MM/DD"} placeholder="To Date" />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>

                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isUpload && <UploadModal onClose={uploadClose} />}
        </div>
    )

}

export default CohortSetup;